export const CustomMonitoringTag = 'FEDOPS_INTERACTION_NAME';

export enum FedOpsInteraction {
  SubmitFiles = 'submit-files',
  ImageLoadedAfterMediaStudioSave = 'image-loaded-after-media-studio-save',
  StorageQuotaDataLoad = 'storage-quota-data-load',
  OpenUploadDialog = 'open-upload-dialog',
  ShowRelatedItems = 'show-related-items',
  MultiSearch = 'multi-search',
  ParseListItems = 'parse-list-items',
  PlatformizedListItems = 'platformized-list-items',
}
